import { Contact, Gender, User, UserLevel, UserType } from 'src/types'

export type InitialValues = User & {
  change_password?: boolean
  emailContact?: Contact
  login_splited?: string
  login_sufix?: string
  phoneContact?: Contact
}

export const initialValues: InitialValues = {
  active: true,
  address: null,
  agree_terms: false,
  auditor: false,
  birthdate: null,
  change_password: false,
  code: null,
  contacts: null,
  contract_id: null,
  contract: null,
  cost_center_id: null,
  cost_center: null,
  dashboard: false,
  driver_license_expires_on: null,
  driver_license_number: null,
  emailContact: {} as Contact,
  first_name: null,
  gender: Gender.M,
  last_name: null,
  login_splited: null,
  login_sufix: null,
  login: null,
  must_change_password: true,
  organization_id: null,
  passport_expires_on: null,
  passport_number: null,
  password: null,
  phoneContact: {} as Contact,
  photo: null,
  position: null,
  preferred_language: 'PT',
  reference_id: null,
  reference: null,
  requester: false,
  role_group_trees: [],
  role_group: null,
  tenant_id: null,
  theme: 'DEFAULT',
  timezone: null,
  user_id: null,
  user_level_type: null,
  user_trees: [
    {
      parent_id: null,
      user_level_group_trees: [{ user_level_type: UserLevel.User }]
    }
  ],
  user_type: UserType.User,
  vat_number: null
}
